<template>
  <div  :class="[prefixCls]">
    <div :class="[prefixCls + '-popper']" >
      <div :class="[col.class||'' +' '+ prefixCls + '-content'+' table-edit-btn']">
          <Button v-for="(item, index) in editCfg.btns" :key="index" 
              v-if="!getNotVisible(item)"
              :ref="'button'+index"
              :type="item.type"
              :disabled="disabled||getBtnDisabled(item)"
              :disabledTime="item.disabledTime"
              :notTimeout="item.notTimeout||false"
              :iconPrefixCls="item.iconPrefixCls"
              :icon="getIcon(item)"
              :iconSize='item.iconSize||(!item.text?"16":"12")'
              :iconColor='getIconColor(item)'
              :color="getColor(item)"
              :loading="item.loading"
              :title="getTitle(item)"
              :isCopy="item.isCopy"
              v-perm:value="item['v-perm']||'(\'1'"
              @click="item.onClick&&item.onClick(col,row,rowOriginal)">{{getText(item)}}</Button>
      </div>
    </div>
  </div>
</template>
<script>
import Tooltip from '../../tooltip/tooltip.vue';
const prefixCls = "table-edit";
export default {
  name: "plugBtn",
  components:{Tooltip},
  computed: {
  },
  props: {
    col: [String, Number, Object],
    row: [String, Number, Object],
    rowOriginal:[String, Number, Object],
    editCfg: Object,
    disabled: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    always: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: [String, Number]
    }
  },
  data() {
    return {
      prefixCls: prefixCls,
      selectData: "",
      showTooltip: false
    };
  },
  watch: {
  },
  methods: {
    getIcon(item){
      return item.setIcon?item.setIcon(this.col,this.row,this.editCfg,this.rowOriginal) : item.icon;
    },
    getIconColor(item){
      return item.setIconColor?item.setIconColor(this.col,this.row,this.editCfg,this.rowOriginal) : item.iconColor;
    },
    getBtnDisabled(item){
      return item.setBtnDisabled?item.setBtnDisabled(this.col,this.row,this.editCfg,this.rowOriginal) : item.disabled;
    },
    getTitle(item){
      return item.setTitle?item.setTitle(this.col,this.row,this.editCfg,this.rowOriginal) : item.title;
    },
    getText(item){
      return item.setText?item.setText(this.col,this.row,this.editCfg,this.rowOriginal) : item.text;
    },
    getNotVisible(item){
      return item.setNotVisible?item.setNotVisible(this.col,this.row,this.editCfg,this.rowOriginal) : item.notVisible;
    },
    handleBlur() {
      this.$emit("onChangeShowEdit", false);
    },
    getColor(item){
      return item.setColor?item.setColor(this.col,this.row,this.editCfg,this.rowOriginal) : item.color;
    }
  },
  mounted() {
    this.selectData = this.content;
  }
};
</script>




// WEBPACK FOOTER //
// src/components/common/table/plug/btn.vue